<template>
  <div :style="{ fontSize: fontsize + 'em' }">{{ title }}</div>
</template>

<script>
export default {
  name: 'LabelWithCount',
  props: ['count', 'fontsize', 'label'],
  computed: {
    title: function() {
      return `${this.label} (${this.count})`
    }
  }
}
</script>

<style scoped></style>
